import { useState } from 'react'

import {
  Modal,
  ModalProvider,
  SquareDotLoadingIndicator,
  TextField,
} from '@joor/design-system'
import styled from 'styled-components/macro'

import usePortal from 'hooks/usePortal'
import { EMPTY_CELL_CONTENT } from 'shop/products/utils'

import { messages } from '../../constants/messages'
import { OrderData } from '../EditAddressesModal/EditAddressesModal'
import { AddressModalData } from '../EditAddressesModal/hooks/useAddressModalData'
import { useInputFieldKeyHandlers } from '../EditAddressesModal/hooks/useInputFieldKeyHandlers'
import { useUpdateTrackingNumber } from './hooks/useUpdateTrackingNumber'
import { useOrderId } from 'features/Orders/orders.hooks'

type Props = {
  modalData: AddressModalData
  orderData: OrderData
  onClose: () => void
}

export function EditTrackingNumberModal({
  modalData,
  orderData,
  onClose,
}: Props) {
  const { trackingNumber } = orderData

  const orderId = useOrderId()
  const Portal = usePortal()
  const [updatedTrackingNumber, setUpdatedTrackingNumber] =
    useState(trackingNumber)
  const { handleKeyDown } = useInputFieldKeyHandlers()
  const { updateTrackingNumber, loading } = useUpdateTrackingNumber()

  const { loadingAddressModalData } = modalData

  const updateTrackingNumberFunc = async () => {
    if (!!updateTrackingNumber && updatedTrackingNumber !== trackingNumber) {
      await updateTrackingNumber(orderId, updatedTrackingNumber!)
      onClose()
    }
  }

  return (
    <Portal>
      <ModalProvider>
        <Modal
          title={{ text: 'Edit Addresses', iconName: 'edit' }}
          subtitle="Shipping and billing addresses cannot be edited when the order is in shipped status.
          Enter or edit the tracking number below."
          isOpen
          onClose={onClose}
          disableBackgroundClick
        >
          {loadingAddressModalData ? (
            <LoaderContainer>
              <SquareDotLoadingIndicator />
            </LoaderContainer>
          ) : (
            <InputWrapper>
              <TextField
                id={'todo'}
                label={messages.trackingNumber}
                value={updatedTrackingNumber!}
                max={100}
                type="alphanumeric"
                placeholder={EMPTY_CELL_CONTENT}
                onKeyDown={handleKeyDown}
                onChange={(e) => {
                  setUpdatedTrackingNumber(e.target.value)
                }}
              />
            </InputWrapper>
          )}
          <Modal.Actions
            primaryButton={{
              handler: updateTrackingNumberFunc,
              loading: loading,
              text: 'Update Tracking Number',
            }}
            secondaryButtonText="Cancel"
          />
        </Modal>
      </ModalProvider>
    </Portal>
  )
}

const InputWrapper = styled.div`
  width: 50%;
`

const LoaderContainer = styled.div`
  width: 670px;
  height: 375px;
  display: flex;
  justify-content: center;
  align-items: center;
`
